module.exports = __webpack_public_path__ + "files/8fdad992c7af698050aee96e9e05d86d.png";